/* import __COLOCATED_TEMPLATE__ from './address-input-field-admin1.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _class2, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tagName } from '@ember-decorators/component';
import { action, computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import Component from '@ember/component';
import { isNone } from '@ember/utils';
import { isGlobalAddress } from '@square/dashboard-utilities/utils/global-address';
let AddressInputFieldAdmin1 = (_dec = tagName(''), _dec2 = alias('countryAddressDataLocalizer.admin1Name'), _dec3 = alias('countryAddressDataLocalizer.admin1Content'), _dec4 = computed('address.{adminLevel1,administrativeDistrictLevel1}', 'isGlobalAddress'), _dec5 = computed('address'), _dec6 = computed('adminLevel1Property'), _dec(_class = (_class2 = class AddressInputFieldAdmin1 extends Component {
  constructor(...args) {
    super(...args);
    // passed-in
    _defineProperty(this, "address", null);
    _defineProperty(this, "countryAddressDataLocalizer", null);
    _defineProperty(this, "isReadOnly", false);
    _initializerDefineProperty(this, "admin1Name", _descriptor, this);
    _initializerDefineProperty(this, "admin1Content", _descriptor2, this);
  }
  get admin1Level() {
    if (isNone(this.address)) {
      return null;
    }
    return isGlobalAddress(this.address) ? this.address.administrativeDistrictLevel1 : this.address.adminLevel1;
  }
  set admin1Level(value) {
    this.set(this.admin1LevelKeyPath, value);
  }
  get adminLevel1Property() {
    return isGlobalAddress(this.address) ? 'administrativeDistrictLevel1' : 'adminLevel1';
  }
  get admin1LevelKeyPath() {
    return `address.${this.adminLevel1Property}`;
  }
  updateAddress(admin1Option) {
    if (isNone(this.address)) {
      return;
    }
    const property = isGlobalAddress(this.address) ? 'administrativeDistrictLevel1' : 'adminLevel1';
    this.set(`address.${property}`, admin1Option.value);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "admin1Name", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "admin1Content", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "admin1Level", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "admin1Level"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "adminLevel1Property", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "adminLevel1Property"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "admin1LevelKeyPath", [_dec6], Object.getOwnPropertyDescriptor(_class2.prototype, "admin1LevelKeyPath"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateAddress", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "updateAddress"), _class2.prototype), _class2)) || _class);
export { AddressInputFieldAdmin1 as default };